window.getLockedFeatureMessage = function (rank) {
    const reqLevel = window.MRTools?.access_levels?.find(l => l.rank === rank)?.name || 'Unknown';
    return `This feature requires ${reqLevel} (${rank})`;
};

window.showToast = function (message, type = 'lock') {
    let toast = document.getElementById('custom-toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.id = 'custom-toast';
        document.body.appendChild(toast);
    }

    let icon = '';
    if (type === 'lock') icon = '&#128274;';
    else if (type === 'info') icon = '&#8505;&#65039;';
    else if (type === 'success') icon = '&#9989;';

    const prefix = icon ? `<span style="margin-right:8px;">${icon}</span> ` : '';
    toast.innerHTML = `${prefix}${escapeHTML(message)}`;
    toast.style.opacity = '1';

    if (toast.timeoutId) clearTimeout(toast.timeoutId);
    toast.timeoutId = setTimeout(() => {
        toast.style.opacity = '0';
    }, 3000);
};

escapeHTML = function (str) {
    if (str === null || str === undefined) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

window.sanitizeURL = function (url) {
    if (!url) return '#';
    try {
        const parsedUrl = new URL(url, window.location.href);
        if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
            return parsedUrl.href;
        }
    } catch (e) {
        console.warn(`Invalid url ${url}`, e);
    }
    return '#';
}

document.addEventListener('click', function (event) {
    const hint = event.target.closest('.help-hint');
    document.querySelectorAll('.help-hint.is-open').forEach(function (open) {
        if (open !== hint) open.classList.remove('is-open');
    });
    if (hint) {
        hint.classList.toggle('is-open');
        event.stopPropagation();
    }
});

// Standalone PWA iOS landscape layout normalization
if (typeof window !== 'undefined') {
    const isStandalone = Boolean(window.navigator.standalone || (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches));
    if (isStandalone) {
        window.addEventListener('load', function () {
            window.scrollTo(0, 0);
        });
        window.addEventListener('orientationchange', function () {
            setTimeout(function () {
                window.scrollTo(0, 0);
            }, 100);
        });
    }
}